<template>
  <v-layout align-start>
    <v-flex>
      <v-toolbar flat color="white">
        <v-dialog v-model="adModal" max-width="500px">
          <v-card>
            <v-card-title class="headline" v-if="adAccion == 1">Activate Item</v-card-title>
            <v-card-title class="headline" v-if="adAccion == 2">Deactivate Item</v-card-title>
            <v-card-text>
              You have selected to
              <span v-if="adAccion == 1" class="blue--text">ACTIVATE</span>
              <span v-if="adAccion == 2" class="red--text">DEACTIVATE</span>
              the item {{ adNombre }}
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="activarDesactivarCarrar()">Cancel</v-btn>

              <v-btn v-if="adAccion == 2" color="red darken-1" text @click="desactivar()">Deactivate</v-btn>

              <v-btn v-if="adAccion == 1" color="orange darken-1" text @click="activar()">Activate</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="comprobanteModal" max-width="1000px">
          <v-card>
            <v-card-title class="headline">
              <v-btn @click="crearPDF()" class="mr-3"><v-icon>print</v-icon></v-btn>Collection receipt
            </v-card-title>
            <v-card-text>
              <div id="factura">
                <header>
                  <div id="logo">
                    <img src="../assets/Logo.png" id="imagen" />
                  </div>
                  <div id="datos">
                    <p id="encabezado">
                      <b>XWY E&SD, LLC<br />427 NE 112TH Street,<br />MIAMI, Fl.
                        33161,<br />
                        PHONE: 786-329-0191<br />
                        wjimenez@xwyesd.com</b>
                    </p>
                  </div>
                  <div id="fact">
                    <p>
                      {{ tipo_comprobante }}<span> # </span>{{ detalles.num_comp_cobro }}<br />
                      <span>Date: </span>{{ fecha }}<br />
                      <span>Original</span>
                    </p>
                  </div>
                </header>
                <br />
                <section>
                  <div>
                    <table id="facliente">
                      <tbody>
                        <tr>
                          <td id="cliente">
                            <strong>Customer: {{ personaToPrint.nombre }}</strong><br />
                            <!-- <strong>Tax ID :</strong> -->
                            <!-- {{ persona.num_documento }}<br /> -->
                            <strong>Address: </strong>{{ personaToPrint.direccion }}<br />
                            <strong>Phone: </strong> {{ personaToPrint.telefono
                            }}<br />
                            <strong>Email: </strong> {{ personaToPrint.email }}
                            <br />
                            <strong>Invoice: </strong>
                            {{ detalles.num_comprobante_venta }}
                            <!-- {{ nombre_proyecto }} -->
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </section>
                <br />
                <section>
                  <div>
                    <table id="facarticulo">
                      <thead>
                        <tr id="fa">
                          <th>INVOICE</th>
                          <th>PAYMENT DETAILS</th>
                          <th>TOTAL </th>
                          <th>PAYMENT</th>
                          <th>PENDING</th>
                          <th>USER</th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- v-for="det in detalles" :key="det._id" -->
                        <tr>
                          <td style="text-align: center">
                            {{ detalles.num_comprobante_venta }}
                          </td>
                          <td style="text-align: center">
                            {{ detalles.detalles_pago }}
                          </td>
                          <td style="text-align: center">
                            {{ parseFloat(detalles.total_factura).toFixed(2) }}
                          </td>
                          <td style="text-align: center">
                            {{ parseFloat(detalles.total_pagado).toFixed(2) }}
                          </td>
                          <td style="text-align: center">
                            {{
                              parseFloat(detalles.total_pendiente).toFixed(2)
                            }}
                          </td>
                          <td style="text-align: center">
                            {{ user }}
                          </td>
                        </tr>
                      </tbody>
                      <!-- <tfoot>
                        <br />
                        <tr>
                          <th></th>
                          <th></th>
                          <th></th> -->
                      <!-- <th style="text-align: left, paddin left: 25px">
                            Sub Total
                          </th>
                          <th style="text-align: right">
                            US${{
                              parseFloat(
                                (totalParcial = calcularTotal)
                              ).toFixed(2)
                            }}
                          </th>
                        </tr>
                        <tr>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th style="text-align: left, paddin left: 25px">
                            Tax ({{ impuesto }}%)
                          </th>
                          <th style="text-align: right">
                            US${{
                              (totalImpuesto = parseFloat(
                                (totalParcial * impuesto) / 100
                              )).toFixed(2)
                            }}
                          </th>
                        </tr>
                        <tr>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th style="text-align: left, paddin left: 25px">
                            Total + Tax
                          </th>
                          <th style="text-align: right">
                            US${{
                              (total = parseFloat(
                                totalImpuesto + totalParcial
                              )).toFixed(2)
                            }}
                          </th>
                        </tr>
                        <tr>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th style="text-align: left, paddin left: 25px">
                            Payment received
                          </th>
                          <th style="text-align: right">
                            US${{
                              (total_pagado = parseFloat(pago).toFixed(2))
                            }}
                          </th> -->
                      <!-- </tr> -->
                      <!-- <tr>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th style="text-align: left, paddin left: 25px">
                            Pending Payment
                          </th>
                          <th style="text-align: right">
                            US${{
                              (total_pagado = parseFloat(total - pago).toFixed(
                                2
                              ))
                            }}
                          </th>
                        </tr> -->
                      <!-- </tfoot> -->
                    </table>
                  </div>
                </section>
                <br />
                <br />
                <footer>
                  <div id="gracias">
                    <p><b>Thank you for using my services!</b></p>
                  </div>
                </footer>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn @click="ocultarComprobante()" color="blue darken-1" text>Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table :headers="headers" :items="cobros" :search="search" class="elevation-1" v-if="verNuevo == 0">
        <template v-slot:[`item.opciones`]="{ item }">
          <v-icon class="mr-2" small @click="editarPago(item)"> edit </v-icon>
          <v-icon class="mr-2" color="success" small @click="mostrarComprobante(item)">
            print
          </v-icon>
          <v-icon class="mr-2" color="red" small @click="eliminarFactura(item)">
            delete
          </v-icon>
        </template>

        <template v-slot:[`item.estado`]="{ item }">
          <div v-if="item.estado">
            <span class="blue--text">Acept</span>
          </div>
          <div v-else>
            <span class="red--text">Cancel</span>
          </div>
        </template>
        <template v-slot:top>
          <v-toolbar text>
            <v-toolbar-title>Income</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field v-if="verNuevo == 0" class="text-xs-center" v-model="search" append-icon="search"
              label="Search" single-line hide-details></v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="primary" v-if="verNuevo == 0" @click="mostrarNuevo()" dark class="mb-2">Make a Payment</v-btn>
          </v-toolbar>
        </template>

        <template v-slot:no-data>
          <v-btn color="primary" @click="listar()"> Reset </v-btn>
        </template>
      </v-data-table>

      <v-container grid-list-sm class="pa-4 white" v-if="verNuevo == 1">
        <v-layout row wrap>
          <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
            <v-select v-model="comprobantes" :items="list_comprobantes" label="Type of document"></v-select>
          </v-col>

          <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
            <v-select v-model="opcion_pago" :items="list_opcion_pago" label="method of Payment"></v-select>
          </v-col>
          <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
            <v-text-field v-model="detalles_pago" label="Paid Details"></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
            <v-autocomplete v-if="!editMode" :items="personas" v-model="persona" label="Client"></v-autocomplete>
            <v-text-field v-else v-model="persona" disabled label="Client"></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
            <v-select v-if="!editMode" v-model="num_comprobante_venta" :items="list_comprobantes_venta"
              label="Invoice Number" @click="buscarNumInvoice(persona)"></v-select>
            <!-- </v-col>
					<v-col v-else cols="12" xs="12" sm="4" md="4" lg="4" xl="4"> -->
            <v-text-field v-else disabled v-model="num_comprobante_venta" label="Invoice Number"></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
            <v-text-field v-if="!editMode" v-model="pago_actual" label="Amount to Pay"></v-text-field>
            <v-text-field v-else disabled v-model="pago_actual" label="Amount to Pay"></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="2" md="2" lg="2" xl="2" v-show="errorArticulo">
            <div class="red--text" v-text="errorArticulo"></div>
          </v-col>
        </v-layout>
        <v-flex cols="12" xs="12" sm="12" md="12" v-show="valida">
          <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v"></div>
        </v-flex>
        <v-flex cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="mt-2">
          <v-btn class="mr-2 white--text" color="primary" darken-1 text @click.native="ocultarNuevo()">Cancel</v-btn>
          <v-btn v-if="verDetalle == 0" color="success" @click.native="guardar()">Save</v-btn>
          <v-btn v-if="editMode == true" color="success" @click.native="guardarEdicion()">Save Edition</v-btn>
        </v-flex>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'

export default {
  data() {
    return {
      itemToEdit: {},
      personaToPrint: {},
      editMode: false,
      itemCompleto: {},
      dialogDelete: false,
      dialog: false,
      search: '',
      cobros: [],
      headers: [
        { text: 'Opctions', value: 'opciones', sortable: false },
        { text: 'User', value: 'usuario.nombre', sortable: true },
        { text: 'Client', value: 'persona.nombre', sortable: true },
        {
          text: 'Document Type',
          value: 'tipo_comprobante',
          sortable: true,
        },
        {
          text: 'Payment ID',
          value: 'num_comp_cobro',
          sortable: true,
        },
        {
          text: 'Invoice ID',
          value: 'num_comprobante_venta',
          sortable: false,
        },
        { text: 'Payment Mode', value: 'opcion_pago', sortable: false },
        { text: 'Date', value: 'createdAt', sortable: true },
        { text: 'Total', value: 'total_factura', sortable: false },
        { text: 'Total Paid', value: 'total_pagado', sortable: false },
        { text: 'Total Pending', value: 'total_pendiente', sortable: false },
        { text: 'Status', value: 'estado', sortable: false },
      ],
      _id: '',
      persona: '',
      personas: [],
      id_factura: '',
      num_comp_cobro: '',
      detalles_pago: '',
      list_opcion_pago: [
        'CASH',
        'CHECK',
        'CREDIT CARD',
        'DEBIT CARD',
        'OTHERS',
      ],
      opcion_pago: '',
      pago_actual: 0,
      total_factura: 0,
      total_pagado: 0,
      total_pendiente: 0,
      tipo_comprobante: '',
      list_comprobantes: ['PAYMENT', 'RECEIPT'],
      comprobantes: '',
      num_comprobante_venta: '',
      list_comprobantes_venta: [],
      list_comprobantes_ventaId: [],
      cabeceraDetalles: [
        { text: 'Borrar', value: 'borrar', sortable: false },
        { text: 'Articulo', value: 'articulo', sortable: false },
        { text: 'Cantidad', value: 'cantidad', sortable: false },
        { text: 'Precio', value: 'precio', sortable: false },
        { text: 'Descuento', value: 'descuento', sortable: false },
        { text: 'Sub Total', value: 'subtotal', sortable: false },
      ],
      detalles: [],
      verNuevo: 0,
      errorArticulo: null,
      total: 0,
      totalParcial: 0,
      // totalImpuesto: 0,
      articulos: [],
      texto: '',
      precio_venta: '',
      descripcion: '',
      headerArticulo: [
        //TODO: Cambiar por los datos de articulo por cobro
        { text: 'Seleccionar', value: 'seleccionar', sortable: false },
        { text: 'Codigo', value: 'codigo', sortable: false },
        { text: 'Nombre', value: 'nombre', sortable: true },
        { text: 'Categoria', value: 'categoria.nombre', sortable: true },
        { text: 'Stock', value: 'stock', sortable: false },
        { text: 'Precio Venta', value: 'precio_venta', sortable: false },
        { text: 'Descripcion', value: 'descripcion', sortable: false },
        { text: 'Estado', value: 'estado', sortable: false },
      ],
      verDetalle: 0,
      valida: 0,
      validaMensaje: [],
      adModal: 0,
      adAccion: 0,
      adNombre: '',
      adId: '',
      comprobanteModal: 0,
      fecha: null,
      user: '',
    }
  },
  computed: {
    calcularTotal: function () {
      let resultado = 0.0
      for (let i = 0; i < this.detalles.length; i++) {
        resultado =
          resultado +
          this.detalles[i].cantidad * this.detalles[i].precio -
          this.detalles[i].descuento
      }
      return resultado
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogDelete(val) {
      val || this.closeDelete()
    },
  },

  created() {
    this.listar()
    this.selectPersona()
  },

  methods: {
    //Aqui se inicia la cracion de un pdf para la factura
    crearPDF() {
      let me = this
      var quotes = document.getElementById('factura')
      html2canvas(quotes).then(function (canvas) {
        var imgData = canvas.toDataURL('image/png')
        var imgWidth = 210
        var pageHeight = 295

        var imgHeight = (canvas.height * imgWidth) / canvas.width
        var heightLeft = imgHeight

        var doc = new jsPDF('p', 'mm', 'a4')
        var position = 0

        doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
        heightLeft -= pageHeight

        while (heightLeft >= 0) {
          position = heightLeft - imgHeight
          doc.addPage()
          doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
          heightLeft -= pageHeight
        }
        doc.save(`PaymentReceipt#${me.detalles.num_comp_cobro}.pdf`)
      })
    },
    //Convertir timestamp createdAt a fecha
    convertirFecha(createdAt) {
      let fecha = new Date(createdAt)
      let dia = fecha.getDate()
      let mes = fecha.getMonth() + 1
      let anio = fecha.getFullYear()
      // let hora = fecha.getHours();
      // let minutos = fecha.getMinutes();
      // let segundos = fecha.getSeconds();
      let fechaFinal = mes + '/' + dia + '/' + anio //+" " +hora +":" +minutos +":" +segundos
      return fechaFinal
    },
    //Convertir timestamp createdAt a fecha
    fechaToSerieComprobante() {
      let fecha = new Date()
      // let dia = fecha.getDate();
      let mes = fecha.getMonth() + 1
      let anio = fecha.getFullYear()
      // let hora = fecha.getHours();
      // let minutos = fecha.getMinutes();
      // let segundos = fecha.getSeconds();
      let fechaFinal = mes + '-' + anio //+" " +hora +":" +minutos +":" +segundos
      return fechaFinal
    },
    mostrarComprobante(item) {
      this.limpiar()
      this.listarDetallesCobro(item._id)
      this.tipo_comprobante = item.tipo_comprobante
      this.num_comprobante = item.num_comp_cobro
      this.fecha = this.convertirFecha(item.createdAt)
      this.persona = item.persona._id
      this.usuario = item.usuario._id
      this.comprobanteModal = 1
    },
    eliminarFactura(item) {
      let me = this
      const id = item._id
      const token = this.$store.state.token
      console.log('ID', id)
      let headersList = {
        Accept: '*/*',
        token: token,
        'Content-Type': 'applicaton/json',
      }

      let bodyContent = JSON.stringify({
        _id: id,
      })

      let reqOptions = {
        url: 'venta/remove',
        method: 'DELETE',
        headers: headersList,
        data: bodyContent,
      }

      let response = axios
        .request(reqOptions)
        .then(function (response) {
          console.log(respone.data)
          me.listar()
        })
        .catch(function (error) {
          console.erro(error)
        })
    },
    editarPago(item) {
      console.log(item)
      // me.itemCompleto = item
      this.limpiar()
      this._id = item._id
      this.id_factura = item.id_factura._id
      this.num_comp_cobro = item.num_comp_cobro
      this.num_comprobante_venta = item.num_comprobante_venta
      this.opcion_pago = item.opcion_pago
      this.pago_actual = item.pago_actual
      this.persona = item.persona._id
      this.tipo_comprobante = item.tipo_comprobante
      this.detalles_pago = item.detalles_pago
      this.total_factura = item.total_factura
      this.total_pagado = item.total_pagado
      this.total_pendiente = item.total_pendiente
      this.itemToEdit = {
        _id: item._id,
        id_factura: item.id_factura._id,
        num_comp_cobro: item.num_comp_cobro,
        num_comprobante_venta: item.num_comprobante_venta,
        opcion_pago: this.opcion_pago,
        pago_actual: item.pago_actual,
        persona: item.persona._id,
        tipo_comprobante: this.tipo_comprobante,
        detalles_pago: this.detalles_pago,
        total_factura: item.total_factura,
        total_pagado: item.total_pagado,
        total_pendiente: item.total_pendiente,
      }
      this.verNuevo = 1
      this.verDetalle = 1
      this.editMode = true
    },
    ocultarComprobante() {
      this.comprobanteModal = 0
    },
    selectPersona() {
      let me = this
      let personaArray = []
      let header = { Token: this.$store.state.token }
      let configuracion = { headers: header }
      axios
        .get('persona/listClientes', configuracion)
        .then(function (response) {
          personaArray = response.data
          console.log(personaArray)
          personaArray.map(function (x) {
            me.personas.push({ text: x.nombre, value: x._id })
            me.user = x.usuario
          })
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    buscarNumInvoice(persona) {
      console.log(persona)
      let me = this
      let ventaArray = []
      me.errorArticulo = null
      me.list_comprobantes_venta = []
      let header = { Token: this.$store.state.token }
      let configuracion = { headers: header }
      axios
        .get('venta/list', configuracion)
        .then((response) => {
          ventaArray = response.data
          console.log('VentaArray: ', ventaArray)
          console.log(ventaArray)
          ventaArray.forEach((x) => {
            if (x.persona._id == persona && x.pagado < x.total) {
              me.pago_actual = (x.total - x.pagado).toFixed(2)
              me.list_comprobantes_venta.push({
                text: x.serie_comprobante + '-' + x.num_comprobante,
                value: x._id,
              })
            }
          })
          console.log('Lista de Facturas: ', me.list_comprobantes_venta)
        })
        .catch(function (error) {
          me.errorArticulo = 'No existe el articulo'
        })
    },
    agregarDetalle(data) {
      this.errorArticulo = null
      if (this.encuentra(data._id) == true) {
        this.errorArticulo = 'El articulo ya ha sido agregado'
      } else {
        this.detalles.push({
          _id: data._id,
          articulo: data.nombre,
          cantidad: 1,
          precio: data.precio_venta.toFixed(2),
          descuento: 0,
        })
      }
      this.codigo = ''
      this.texto = ''
    },
    encuentra(id) {
      let sw = 0
      for (let i = 0; i < this.detalles.length; i++) {
        if (this.detalles[i]._id == id) {
          sw = true
        }
      }
      return sw
    },
    eliminarDetalle(arr, item) {
      let i = arr.indexOf(item)
      if (i != -1) {
        arr.splice(i, 1)
      }
    },
    listarArticulos() {
      let me = this
      let header = { Token: this.$store.state.token }
      let configuracion = { headers: header }
      axios
        .get('articulo/list?valor=' + this.texto, configuracion)
        .then(function (response) {
          me.articulos = response.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    mostrarModalArticulos() {
      this.dialog = true
    },
    listarDetallesCobro(id) {
      let me = this
      let header = { Token: this.$store.state.token }
      let configuracion = { headers: header }
      axios
        .get('cobro?id=' + id, configuracion)
        .then(function (response) {
          me.detalles = response.data.data
          console.log('Detalles: ', me.detalles)
          me.user = me.detalles.usuario
          console.log('Usuario: ', me.user.nombre)
          me.user = me.user.nombre
          me.personaToPrint = response.data.data.persona
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    verIngreso(item) {
      this.tipo_comprobante = item.tipo_comprobante
      this.num_comprobante_venta = item.num_comprobante_venta
      this.num_comprobante = item.num_comp_cobro
      this.opcion_pago = item.opcion_pago
      this.pago_actual = item.pago_actual
      this.total_factura = item.total_factura
      this.total_pagado = item.total_pagado
      this.total_pendiente = item.total_pendiente
      this.persona = item.persona._id
      this.verNuevo = 1
      this.verDetalle = 1
    },
    listar() {
      let me = this
      let header = { Token: this.$store.state.token }
      let configuracion = { headers: header }
      axios
        .get('cobro/list', configuracion)
        .then((response) => {
          me.cobros = response.data
          console.log(me.cobros)
          me.cobros.forEach((element) => {
            element.createdAt = this.convertirFecha(element.createdAt)
          })
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    limpiar() {
      this.tipo_comprobante = ''
      this.num_comprobante_venta = ''
      this.num_comprobante = ''
      this.opcion_pago = ''
      this.pago_actual = 0
      this.total_factura = 0
      this.total_pagado = 0
      this.total_pendiente = 0
      this.persona = ''
      this.comprobantes = []
      this.detalles = []
      this.detalles_pago = []
    },
    validar() {
      this.valida = 0
      this.validaMensaje = []
      if (!this.persona) {
        this.validaMensaje.push('Seleccione un cliente.')
      }
      if (!this.tipo_comprobante) {
        this.validaMensaje.push('Seleccione un tipo de comprobante.')
      }
      // if (!this.num_comprobante) {
      // 	this.validaMensaje.push("Ingrese el numero de comprobante.");
      // }
      // if (!this.nombre_proyecto) {
      //   this.validaMensaje.push('Ingrese el nombre del proyecto.')
      // }
      // if (!this.impuesto) {
      // 	this.validaMensaje.push("Ingrese valor de impuesto.");
      // }
      if (this.detalles.length <= 0) {
        this.validaMensaje.push('Ingrese al menos un articulo al detalles.')
      }

      if (this.validaMensaje.length) {
        this.valida = 1
      }
      return this.valida
    },
    mostrarNuevo() {
      this.verNuevo = 1
    },
    ocultarNuevo() {
      this.itemCompleto = {}
      this.editMode = false
      this.verNuevo = 0
      this.verDetalle = 0
      this.limpiar()
    },
    async guardar() {
      let me = this
      let headersList = {
        Accept: '*/*',
        'Content-Type': 'application/json',
        Token: this.$store.state.token,
      }
      let bodyContent = JSON.stringify({
        id_factura: me.num_comprobante_venta,
        persona: me.persona,
        usuario: me.$store.state.usuario._id,
        tipo_comprobante: me.comprobantes,
        opcion_pago: me.opcion_pago,
        detalles_pago: me.detalles_pago,
        pago_actual: me.pago_actual,
      })

      axios
        .post('cobro', bodyContent, { headers: headersList })
        .then(function (response) {
          console.log(response.data)
          me.limpiar()
          me.close()
          me.listar()
          return alert(response.data.msg)
        })
        .catch(function (error) {
          console.log(error)
          return alert(error)
        })

      // let response = await fetch('http://127.0.0.1:3000/api/cobro', {
      //   method: 'POST',
      //   headers: headersList,
      //   body: bodyContent,
      // })

      // let data = await response.json()
      // console.log(data)
      // if (!data.ok) {
      //   return alert(data.msg)
      // }
      // me.limpiar()
      // me.close()
      // me.listar()
      // return alert(data.msg)
    },
    async guardarEdicion() {
      this.itemToEdit.opcion_pago = this.opcion_pago
      this.itemToEdit.tipo_comprobante = this.tipo_comprobante
      this.itemToEdit.detalles_pago = this.detalles_pago
      console.log(this.itemToEdit)
      // let me = this
      // let headersList = {
      // 	"Accept": "*/*",
      // 	"token": this.$store.state.token,
      // 	"Content-Type": "application/json"
      // }

      // let bodyContent = JSON.stringify({
      // 	"_id": "64f4adcf33a75174ece9d932",
      // 	"usuario": "6140f5f0a8ec8d179e5a7311",
      // 	"persona": "622226b9d2d7c3ff1d02d140",
      // 	"id_factura": "6414be2595950412f3b69178",
      // 	"num_comprobante_venta": "03-2022-1104",
      // 	"num_comp_cobro": "1033",
      // 	"tipo_comprobante": "Payment",
      // 	"total_factura": 320,
      // 	"opcion_pago": "Check",
      // 	"detalles_pago": "Banck: Chase, Check#: 1156",
      // 	"pago_actual": 320,
      // 	"total_pagado": 320,
      // 	"total_pendiente": 0
      // })

      // try {
      // 	let response = await fetch("http://127.0.0.1:3000/api/cobro", {
      // 		method: "PUT",
      // 		headers: headersList,
      // 		body: bodyContent
      // 	})
      // 	let data = await response.json()
      // 	if (!data.ok) {
      // 		console.log(data)
      // 		return alert(data.msg)
      // 	}
      // 	me.limpiar()
      // 	me.close()
      // 	me.listar()
      // 	me.editMode = false
      // 	return alert(data.msg)
      // } catch (error) {
      // 	console.log(error)
      // 	return alert(error.msg)
      // }

      // me.editMode = false
      // me.itemCompleto = {}
    },
    activarDesactivarMostrar(accion, item) {
      this.adModal = 1
      this.adNombre = item.num_comprobante
      this.adId = item._id
      if (accion == 1) {
        this.adAccion = 1
      } else if (accion == 2) {
        this.adAccion = 2
      } else {
        adModal = 0
      }
    },
    activarDesactivarCarrar() {
      this.adModal = 0
    },

    activar() {
      let me = this
      let header = { Token: this.$store.state.token }
      let configuracion = { headers: header }
      axios
        .put('venta/activate', { _id: this.adId }, configuracion)
        .then(function (response) {
          me.adModal = 0
          me.adAccion = 0
          me.adNombre = ''
          me.adId = ''
          me.listar()
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    desactivar() {
      let me = this
      let header = { Token: this.$store.state.token }
      let configuracion = { headers: header }
      axios
        .put(
          'venta/deactivate',
          {
            _id: this.adId,
          },
          configuracion
        )
        .then(function (response) {
          me.adModal = 0
          me.adAccion = 0
          me.adNombre = ''
          me.adId = ''
          me.listar()
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    close() {
      this.dialog = false
      this.texto = ''
    },
  },
}
</script>
<style>
#factura {
  padding: 20px;
  font-family: Arial, sans-serif;
  font-size: 16px;
}

#logo {
  float: left;
  margin-left: 2%;
  margin-right: 2%;
}

#imagen {
  width: 75px;
}

#fact {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}

#datos {
  float: left;
  margin-top: 0%;
  margin-left: 2%;
  margin-right: 2%;
  /*text-align: justify;*/
}

#encabezado {
  text-align: left;
  margin-left: 10px;
  margin-right: 10px;
  font-size: 16px;
}

section {
  clear: left;
}

#cliente {
  text-align: left;
}

#facliente {
  width: 50%;
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 15px;
}

#fa {
  color: #ffffff;
  font-size: 14px;
}

#facarticulo {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  padding: 20px;
  margin-bottom: 15px;
}

#facarticulo thead {
  padding: 20px;
  /* background: #2183e3; */
  background: #003399;
  text-align: center;
  border-bottom: 1px solid #ffffff;
}

#gracias {
  text-align: center;
}
</style>
